export default __webpack_public_path__ + "static/media/aboutusgraphics1.b88c758d.webp";